import React from "react";
import MediaTypeDisplay from "./MediaTypeDisplayComponent";
import { MediaAttachment } from "src/shared/types/src";

type iProps = {
    media: MediaAttachment[]
}

const ThreeAttachments: React.FC<iProps> = ({ media }) => {

    return (
        <div className="d-flex mx-n-4 media-collage-3 flex-wrap">
            <div className="pd-x-4">
                <div className="media-collage-item">
                    <MediaTypeDisplay media={media[0]} collageDisplay={true} />
                </div>
            </div>
            <div className="pd-x-4">
                <div className="media-collage-item">
                    <MediaTypeDisplay media={media[1]} collageDisplay={true} />
                </div>
                <div className="media-collage-item">
                    <MediaTypeDisplay media={media[2]} collageDisplay={true} />
                </div>
            </div>
        </div>
    )
}

export default ThreeAttachments;